import React from 'react';
import { DateRangePicker, LabeledElement } from 'components/form-elements';
import { Popup } from 'components/Popup';
import { LabeledDateTrigger } from './components';

export const LabeledDateRangePicker = ({ id, label, selectedDate, onChange }) => (
  <LabeledElement
    label={label}
    id={id}
  >
    <Popup
      trigger={(
        <div id={id}>
          <LabeledDateTrigger
            selectedDate={selectedDate}
            onChange={onChange}
          />
        </div>
      )}
    >
      <DateRangePicker
        selectedDate={selectedDate}
        onChange={onChange}
      />
    </Popup>
  </LabeledElement>
);
